<template lang="pug">
  v-container
    v-row
      slot(name="resume")
    v-row.my-4
      slot(name="feed")
</template>

<script>
import DecoratorHeader from '@iez/components/decorators/header/'

export default {
  components: {
    DecoratorHeader
  }
}
</script>
